module.exports = __webpack_public_path__ + "static/media/mainbanner_keyword_bg.bfefdce6.jpg";